export default __webpack_public_path__ + "static/FTG_LP_Verified-3e8ce8473b98ac5bd4817834b9478f76.png";